module.exports = __webpack_public_path__ + "img/valladolid-logo-icon.2171e95e.png";